import * as React from 'react'
import { ModuleContextProvider } from '../hooks/ModuleContext'
import { ModuleController } from '@/ModuleController'
import { SegmentContextProvider } from '../hooks/SegmentContext'

export const WebSelfService = (props: { apiUrl: string | null; userId: string | null; segmentKey: string | null }) => {
  const [userId, setUserId] = React.useState<string>(props.userId ?? '')

  window.SelfServiceBallon.updateProps = (props: { userId: string | null }) => {
    if (props.userId) {
      setUserId(props.userId)
    }
  }

  return (
    <SegmentContextProvider writeKey={props.segmentKey ?? ''}>
      <ModuleContextProvider>
        <ModuleController apiUrl={props.apiUrl ?? ''} userId={userId} />
      </ModuleContextProvider>
    </SegmentContextProvider>
  )
}
